import { ClubPage } from "components/ClubPage"
import { Wrapper } from "components/Wrapper"
import { Text } from "components/Text"
import { Card, CardContent } from "components/Card"
import { Button } from "components/Button"
import { useTranslator } from "components/Translator"
import { Image } from "components/Image"

export function ClubPartnerShowPage({ partner }) {
  const translator = useTranslator()

  return (
    <ClubPage title={partner.name}>
      <Wrapper>
        <div className="flex flex-col space-y-6 md:flex-row md:space-y-0 md:space-x-8">
          <div className="md:w-52 lg:w-64 md:shrink-0">
            <Card spacing="small">
              <CardContent>
                <div className="h-48">
                  <Image
                    imageFile={partner.imageFile}
                    size="w640"
                    alt=""
                    className="w-full h-full object-contain object-center"
                  />
                </div>
              </CardContent>
            </Card>
          </div>
          <div className="space-y-6">
            <Text tag="div">
              <p
                dangerouslySetInnerHTML={{
                  __html: partner.description,
                }}
              />
            </Text>
            <Button href={partner.url} external>
              {translator.trans("club.partner.show.cta", null, "pages")}
            </Button>
          </div>
        </div>
      </Wrapper>
    </ClubPage>
  )
}
